export const scene4Frames = [
// 13
  {
    url: 'Scene13',
    position: {
      yaw: 54.35 * Math.PI / 180,
      pitch: -2.9 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(793px) rotateY(-20deg) skewY(-2deg) scale(0.25)'
      }
    },
    style: {
      width: '864px',
      height: '556px',
      backgroundSize: 'contain',
    }
  },
  // 14
  {
    url: 'Scene14',
    position: {
      yaw: 83.75 * Math.PI / 180,
      pitch: -3.55 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(400px) rotateY(-2deg) skewY(-0.5deg) scale(0.333333333333)'
      }
    },
    style: {
      width: '918px',
      height: '510px',
      backgroundSize: 'contain',
    }
  },
  // 15
  {
    url: 'Scene15',
    position: {
      yaw: 130.15 * Math.PI / 180,
      pitch: -2.7 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(314px) rotateY(15deg) skewY(2deg) scale(0.25)'
      }
    },
    style: {
      width: '744px',
      height: '528px',
      backgroundSize: 'contain',
    }
  },
  // 1
  // {
  //   url: Scene.Scene1,
  //   position: {
  //     yaw: -30.75 * Math.PI / 180,
  //     pitch: -1.6 * Math.PI / 180,
  //   },
  //   transformations: {
  //     perspective: {
  //       extraTransforms: 'perspective(593px) rotateY(40deg) skewY(2deg)'
  //     }
  //   },
  //   style: {
  //     width: '94px',
  //     height: '80px',
  //     backgroundSize: 'contain',
  //   }
  // }
];
